import React, { useCallback, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import {
  WrapperDiv,
  HeaderDiv,
  LoginBoxOuter,
  LoginBox,
  WelcomeTitle,
  WelcomeDesc,
  LoginFooter,
  SignInButton,
} from "./style";
import RackStarLogoDark from "../../logos/RackStarLogo2.png";
import Microsoft from "../../logos/microsoft.png";
import { toast } from "react-toastify";
import logger from "../../helpers/logger";
import { appInsights } from "../../appInsights";
import { CircularProgress } from "@mui/material";

const Login = () => {
  const { instance } = useMsal();
  const [isMicrosoftLoading, setIsMicrosoftLoading] = useState(false);

  // Memoized login handler
  const handleLogin = useCallback(async () => {
    try {
      setIsMicrosoftLoading(true);
      appInsights.trackEvent({
        name: "Login_Attempt",
        properties: {
          timestamp_utc: new Date().toISOString(),
        },
      });
      logger.log("🔄 Starting login process...");
      await instance.loginRedirect(loginRequest);
      logger.log("✅ Login redirect initiated");
      appInsights.trackEvent({
        name: "Login_Success",
        properties: {
          timestamp_utc: new Date().toISOString(),
        },
      });
    } catch (error) {
      logger.error("❌ Login failed:", error);
      toast.error(`Login failed: ${error.message}`);
      appInsights.trackEvent({
        name: "Login_Failure",
        properties: {
          timestamp_utc: new Date().toISOString(),
          error: error.message,
        },
      });
    } finally {
      setIsMicrosoftLoading(false);
    }
  }, [instance]);

  const getYear = new Date().getFullYear();

  // JSX render
  return (
    <WrapperDiv>
      <HeaderDiv>
        <img src={RackStarLogoDark} alt="Logo" />
      </HeaderDiv>
      <LoginBoxOuter>
        <LoginBox>
          <div style={{ marginBottom: "60px" }}>
            <WelcomeTitle>Welcome</WelcomeTitle>
            <WelcomeDesc>Sign in to your account to continue</WelcomeDesc>
          </div>
          <SignInButton
            onClick={handleLogin}
            variant="outlined"
            startIcon={
              <img
                src={Microsoft}
                alt="Microsoft"
                style={{ width: 20, height: 20 }}
              />
            }
            endIcon={
              isMicrosoftLoading ? (
                <CircularProgress size={16} color="primary" />
              ) : null
            }
            fullWidth
            disabled={isMicrosoftLoading}
          >
            Sign in with Microsoft
          </SignInButton>
        </LoginBox>
      </LoginBoxOuter>
      <LoginFooter>
        <p>© {getYear} RackStar. All Rights Reserved</p>
      </LoginFooter>
    </WrapperDiv>
  );
};

export default Login;
